const he = {
    dir: 'rtl',
    page: {
        apiErrorDialogTitle: 'הטבת הההצטרפות שלך הסתיימה',
        apiErrorDialogDescription:
            'הפקת {n} דו”חות בחינם. כדי להמשיך להשתמש במערכת, צריך לעדכן אמצעי תשלום. מעכשיו, כל דו״ח שיופק יעלה {p}',
        apiErrorConfirm: 'עדכון אמצעי תשלום',
    },
    header: {
        title: 'מערכת ניהול לקוחות',
        search: 'חיפוש לקוחות',
        add_client_button: 'לקוח חדש',
    },
    login: {
        subtitle: 'היי, טוב לראות אותך!',
        changePhone: 'הזנת מספר אחר',
        codeWillArrive: 'הקוד יגיע בעוד: {{time}}',
    },
    profileMenu: {
        editProfile: 'עריכת פרופיל',
        settings: 'הגדרות',
        logout: 'התנתק',
        delete: 'מחיקת משתמש',
    },
    notificationsMenu: {
        notifications: 'התראות',
        removeNotifications: 'הסרת כל ההתראות',
        approved: 'בקשה אושרה',
    },
    menu: {
        home: 'ראשי',
        clients: 'לקוחות',
        statistics: 'סטטיסטיקות',
        support: 'תמיכה',
        settings: 'הגדרות',
        logout: 'יציאה מהמערכת',
    },
    form: {
        update: 'עדכון',
        create: 'יצירת',
        link: 'קישור',
        add: 'הוספת',
        keyError: 'נדרש/ת {{key}} חוקי/ת.',
        not: 'לא',
        cancel: 'ביטול',
        save: 'שמירה',
        edit: 'עריכה',
        delete: 'מחיקה',
        confirm: 'אישור',
        goBack: 'חזרה',
        optional: '(לא חובה)',
    },
    general: {
        invalid_password: 'סיסמה חייבת להיות בת 8 תוים לפחות',
        invalid_verify_password: 'הסיסמה לא תואמת את שדה הסיסמה הראשון',
        welcome: 'ברוכים הבאים ל{{appName}}',
    },
    register: {
        smsVerificationText: 'קיבלת קוד אימות למספר {{phone}}',
        verificationCode: 'קוד אימות',
        resend: 'לא קיבלתי, שלח שוב',
        passwordSetupTitle: 'זה הזמן לבחור סיסמה',
        confirmPasswordPlaceholder: 'נא להקליד את הסיסמה פעם נוספת',
        next: 'הבא',
        finish: 'הרשמה',
        updatePassword: 'עדכון סיסמה',
        terms: 'אישור ',
        termsLink: 'תנאי השימוש',
        loginDetails: 'פרטי התחברות',
        phoneDetails: 'מספר טלפון',
        phoneVerification: 'אימות מספר טלפון',
        choosePassword: 'בחירת סיסמה',
        personalDetails: 'פרטים אישיים',
        personalDetailsTitle: 'כמה פרטים אחרונים לפני שמתחילים',
        registerSuccessTitle: 'הרשמה בוצעה בהצלחה!',
        loginButton: 'כניסה למערכת',
    },
    tables: {
        users: 'משתמשים',
        invites: 'מוזמנים',
        accounts: 'חשבונות',
        requests: 'בקשות',
        clients: 'לקוחות',
    },
    accounts: {
        _id: 'ID',
        name: 'שם',
        apiKey: 'Api Key',
        created: 'נוצר',
        updated: 'נערך',
        role: 'תפקיד',
        confirmed: 'מאושר',
        editButtonText: 'עריכת נתונים',
        editImageText: 'עריכת לוגו ארגון',
    },
    users: {
        id: 'מספר תעודת זהות',
        name: 'שם',
        email: 'כתובת מייל',
        orgCode: 'קוד ארגון',
        orgCodePlaceholder: 'את הקוד יש לקבל מהארגון שלך',
        created: 'נוצר',
        role: 'תפקיד',
        firstname: 'שם פרטי',
        lastname: 'שם משפחה',
        address: 'כתובת מגורים',
        Insurance_org_Code: 'קוד ארגון',
        phone: 'מספר טלפון',
        editButtonText: 'עריכת פרופיל',
        editImageText: 'עריכת תמונת פרופיל',
        GenderKods: {
            male: 'זכר',
            female: 'נקבה',
        },
        FamilyStatuss: {
            single: 'רווק',
            married: 'נשוי',
            divorced: 'גרוש',
            widow: 'אלמן',
        },
        Professions: {
            finance: 'פיננסים',
        },
        username: 'שם משתמש',
        usernamePlaceholder: '(טלפון)',
        password: 'סיסמה',
        confirmPassword: 'אימות סיסמה',
        signin: 'התחברות',
        register: 'יצירת חשבון',
        newUser: 'עדיין אין לך חשבון?',
        forgotPassword: 'שכחת סיסמה?',
        rememberMe: 'זכור אותי',
        haveAccount: 'חשבון קיים?',
        enter: 'כניסה',
    },
    invites: {
        _id: 'ID',
        name: 'שם',
        email: 'דוא״ל',
        created: 'נוצר',
        role: 'תפקיד',
    },
    organizations: {
        _id: 'ID',
        created: 'נוצר',
        updated: 'נערך',
        description: 'תיאור',
        name: 'שם',
        order: 'סדר',
        address: 'כתובת',
        area: 'איזור',
        contact: 'איש קשר',
        email: 'דוא״ל',
        facebookUrl: 'קישור פייסבוק',
        homeUrl: 'אתר הבית',
        isActive: 'פעיל',
        lastActive: 'פעילות אחרונה',
        lastAdminMsg: 'הודעת אדמין אחרונה',
        logoUrl: 'לוגו',
        password: 'סיסמא',
        phone: 'טלפון',
        times: 'זמנים',
        username: 'שם משתמש',
    },
    dashboard: {
        done: 'בקשות שאושרו',
        pending: 'בקשות ממתינות',
        expired: 'בקשות ננטשות',
        nextPayment: 'תשלום עד כה',
        helloUser: 'שלום{{firstName}},',
        greeting: 'שיהיה לך יום מעולה!',
        all_statistics_button: 'לכל הסטטיסטיקות',
        all_clients_button: 'לכל הלקוחות',
        periodSelectTitle: 'בחר טווח תאריכים',
        period: '{{from}} - {{to}}',
        periods: {
            fromStartOfMonth: 'החודש',
            lastWeek: 'שבוע אחרון',
            last30Days: '30 יום אחרונים',
            last90Days: '90 יום אחרונים',
            custom: 'אחר',
        },
        from: 'מתאריך',
        to: 'לתאריך',
        tableStatuses: {
            pending: 'ממתינות ({{count}})',
            done: 'אושרו ({{count}})',
            expired: 'ננטשות ({{count}})',
        },
        allRequests: 'כל הבקשות',
        noRequests: 'אין בקשות',
    },
    requests: {
        approvalDate: 'אישור הבקשה',
        name: 'שם המבקש',
        status_pending: 'ממתינה',
        status_done: 'אושרה',
        status_expired: 'ננטשה',
    },
    clients: {
        AccountKey: 'מספר סוכן',
        PlannerClientKey: 'מספר לקוח',
        name: 'שם הלקוח',
        ClientFirstName: 'שם פרטי',
        ClientLastName: 'שם משפחה',
        ClientPhone: 'טלפון נייד',
        GenderKod: 'מין',
        ClientEmail: 'כתובת מייל',
        RequestCreat: 'שליחת בקשה אחרונה',
        RequestEnded: 'תאריך אישור בקשה',
        Status: 'סטטוס בקשה',
        PdfUrl: 'דו"ח',
        personalDetails: 'פרטים אישיים',
        requestsHistory: 'היסטוריית בקשות',
        notes: 'הערות',
        ClientId: 'תעודת זהות',
        ClientIdPhoto: 'תצלום ת.ז',
        FamilyStatus: 'מצב משפחתי',
        ChildrenNumber: 'ילדים',
        spouse: 'בן/בת זוג',
        WorkName: 'מקום עבודה',
        Profession: 'סוג עיסוק',
        ClientStatus: 'סטטוס',
        copyNewRequest: 'העתקת בקשה חדשה',
        sendRequestViaSMS: 'שליחת בקשה חדשה בSMS',
        requestDetails: 'שליחת בקשה לפרטים למספר הטלפון הנייד של הלקוח',
        viewLastReport: 'צפיה בדו"ח האחרון',
        downloadLastReport: 'הורדת דו"ח אחרון',
        downloadXlsxReport: 'הורדת דו"ח אקסל',
        clientCreationDate: 'תאריך יצירת לקוח',
        newClient: 'לקוח חדש',
        connectExistingAccount: 'חיבור לפרופיל קיים',
        Priority: 'עדיפות',
        sendRequest: 'שליחת בקשה',
    },
    clientRequests: {
        RequestCreat: 'תאריך שליחת בקשה',
        RequestEnded: 'תאריך אישור בקשה',
        PdfUrl: 'דו"ח',
        copyToClipboardMessage: 'קישור הועתק',
        sendRequestUrlSuccessMessage: 'בקשה נשלחה בהצלחה',
        requestLinkError: 'לא ניתן לבצע את הפעולה',
        Status: 'סטטוס בקשה',
        done: 'בוצע',
        pending: 'ממתין',
        expired: 'פג תוקף',
        doneNoSendToAgent: 'בוצע ולא נשלח מהלקוח',
    },
    settings: {
        users: 'פרופיל אישי',
        accounts: 'נתוני ארגון',
        payments: 'חיובים ותשלומים',
        crms: 'ממשקים',
        paymentsList: 'תשלומים',
        paymentTypes: 'אמצעי תשלום',
        subscriptions: 'מסלולים ומנויים',
        subscriptionName: 'מסלול {{name}}',
        subscription: 'מנוי',
        totalSubscriptionPrice: 'סה"כ עד כה',
        freeReports: 'דוחו"ת ללא עלות',
        issuedReports: 'דוחו"ת שהופקו   ',
        reports: 'דו"חות',
        reportPrice: 'עלות לדו"ח',
        totalReports: 'סה"כ דוחות',
        subscriptionPrice: 'עלות מנוי',
        subscriptionDescription: 'FamilyBiz',
        changeSubscription: 'החלפת מסלול',
        currentSubscriptionTitle: 'מסלול נוכחי: מסלול {{subscription}}',
        addCreditCardButton: 'הוספת כרטיס אשראי',
        ccNumber: 'מספר כרטיס אשראי',
        ccExpierd: 'תאריך תפוגה',
        ccCvv: 'CVV',
        cvvDescription: '3 ספרות בגב הכרטיס',
        ccName: 'שם בעל הכרטיס',
        ccId: 'ת.ז בעל הכרטיס',
        image_upload_error: 'שגיאה בהעלאת תמונה',
        confirmChangeSubscriptionText:
            'בלחיצה על אישור, המנוי ישתנה והכרטיס יחוייב החל מהחיוב הבא',
        editPaymentDetails: 'עריכת פרטי אשראי',
        paymentList: {
            tableTitles: ['תאריך', 'כרטיס', 'סכום', 'חשבונית'],
        },
        crmsList: {
            termsApproval: 'אישור תנאים',
            termsLink: 'לצפייה בתנאי השימוש',
        },
    },
    support: {
        title: 'תמיכה',
        guides: 'מדריכים',
        commonQuestions: 'שאלות נפוצות',
        searchPlaceholder: 'מה הבעיה בה נתקלת?',
    },
    maxQuotaDialog: {
        title: 'הטבת ההצטרפות שלך הסתיימה',
        button: 'עדכון אמצעי תשלום',
    },
}

export default he
